import React, { memo, forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { context } from '..';
/**
 * A pane wraps the content displayable by a tab
 *
 * @return {jsx}
 */

var Pane = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      tabId = _ref.tabId;

  var _useContext = useContext(context),
      activeTabId = _useContext.activeTabId;

  return tabId !== activeTabId ? null : /*#__PURE__*/React.createElement("div", {
    className: className,
    ref: ref,
    "aria-labelledby": tabId,
    id: "panel:".concat(tabId),
    tabIndex: "0",
    role: "tabpanel"
  }, children);
});
/**
 * PropTypes Validation
 */

var node = PropTypes.node,
    string = PropTypes.string;
Pane.propTypes = {
  /** Anything that can be rendered: numbers, strings, elements or an array (or fragment) */
  children: node,

  /** className needed by styled components */
  className: string,

  /** Tab id */
  tabId: string.isRequired
};
/**
 * Default props.
 */

Pane.defaultProps = {
  children: null,
  className: undefined
};
Pane.displayName = 'Pane';
var StyledPane = styled(memo(Pane)).withConfig({
  displayName: "Pane__StyledPane",
  componentId: "sc-1lykp5j-0"
})(["width:100%;height:100%;"]);
StyledPane.displayName = 'Pane';
export default StyledPane;